class ProductFeature extends HTMLElement {
  static selectors = {
    dialog: '[data-dialog]',
    openButton: '[data-open-dialog]',
    closeButton: '[data-close-dialog]',
    content: '[data-dialog-content]',
  };

  constructor() {
    super();
    this.dialog = null;
    this.controller = new AbortController();
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.controller.abort();
  }

  init() {
    const { dialog, openButton, closeButton, content } = ProductFeature.selectors;
    this.dialog = this.querySelector(dialog);
    if (!this.dialog) return;

    const { signal } = this.controller;

    const openBtn = this.querySelector(openButton);
    if (openBtn) {
      openBtn.addEventListener(
        'click',
        (e) => {
          if (e.target.closest('dialog') || window.matchMedia('(min-width: 990px)').matches) return;
          this.openDialog();
        },
        { signal }
      );
    }

    this.dialog.addEventListener(
      'click',
      (e) => {
        const isOutside = !e.target.closest(content);
        const isCloseBtn = e.target.closest(closeButton);
        if (isOutside || isCloseBtn) {
          this.closeDialog();
        }
      },
      { signal }
    );
  }

  openDialog() {
    this.dialog?.showModal();
  }

  closeDialog() {
    this.dialog?.close();
  }
}

if (!customElements.get('product-feature')) {
  customElements.define('product-feature', ProductFeature);
}


// Header progress bar
class PfSaleProgress extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    document.addEventListener("cart:update", this.onCartUpdate.bind(this), { signal });

    this.init();
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get cartCount() {
    return Number(this.dataset.cartCount || 0);
  }

  get saleLevels() {
    const levels = JSON.parse(this.dataset.saleLevels || "[]");
    return levels.sort((a, b) => a.quantity - b.quantity);
  }

  get maxQuantity() {
    return this.saleLevels.length
      ? this.saleLevels[this.saleLevels.length - 1].quantity
      : 0;
  }

  get needsMorphEvent() {
    return this.dataset.morphEvent == "true";
  }

  init() {
    this.messageEl = this.querySelector("[data-sale-message]");
    this.progressInner = this.querySelector(".pf-csprogress-inner");

    this.updateUI();
  }

  updateUI() {
    const count = this.cartCount;
    const levels = this.saleLevels;
    const maxQty = this.maxQuantity;

    if (!levels.length) return;

    let currentLevel = null;
    let nextLevel = null;

    for (let i = 0; i < levels.length; i++) {
      if (count >= levels[i].quantity) {
        currentLevel = levels[i];
      } else {
        nextLevel = levels[i];
        break;
      }
    }

    let message = "";

    if (!currentLevel) {
      const needed = levels[0].quantity - count;
      message = this.dataset["text-1"]?.replace("{{ quantity }}", needed).replace("{{ discount }}", levels[0].discount_amount);
    } else if (nextLevel) {
      const needed = nextLevel.quantity - count;
      message = this.dataset["text-2"]?.replace("{{ quantity }}", needed).replace("{{ discount }}", nextLevel.discount_amount);
    } else {
      message = this.dataset["text-3"]?.replace("{{ discount }}", currentLevel.discount_amount);
    }

    const progress = maxQty > 0 ? Math.min(count / maxQty, 1) * 100 : 0;

    if (this.progressInner) {
      this.progressInner.style.width = `${progress}%`;
    }

    if (this.messageEl) {
      this.messageEl.innerHTML = `<p>${message}</p>`;
    }
  }

  setCartCount(newCount) {
    this.dataset.cartCount = newCount;
    this.updateUI();
  }

  onCartUpdate(e) {
    const detail = e.detail?.data ?? {};
    const itemCount = detail.itemCount ?? 0;
    const paddingCount = parseInt(detail.paddingProduct || 0);
    const comingFromProductForm = detail.source === "product-form-component";
    const updatedAmount = comingFromProductForm ? this.cartCount + itemCount : itemCount - paddingCount;

    this.setCartCount(updatedAmount);
  }
}

if (!customElements.get("pf-sale-progress")) {
  customElements.define("pf-sale-progress", PfSaleProgress);
}
